// extracted by mini-css-extract-plugin
module.exports = {"table_header":"autorisatie-niveau-grid_table_header__1MUTM"};